import clsx from 'clsx';
import { Field } from 'formik';
import React from 'react';

import styles from './styles.module.scss';

interface AnonymoustPostBlockProps {
  isAnonymous: boolean;
  justify?: 'left' | 'center' | 'right';
}

const AnonymousPostBlock = ({ isAnonymous, justify = 'center' }: AnonymoustPostBlockProps) => {
  return (
    <>
      <div
        className={clsx(styles.anonymousCheckbox, {
          [styles.anonymousCheckboxLeft]: justify === 'left',
          [styles.anonymousCheckboxCenter]: justify === 'center',
          [styles.anonymousCheckboxRight]: justify === 'right',
        })}
      >
        <Field type="checkbox" className="checkbox-input" name="is_anonymous" id="is_anonymous" />
        <span className={styles.anonymousCheckboxText}>Post Anonymously?</span>
      </div>
      <div
        className={clsx(styles.anonymousHelperText, {
          [styles.anonymousHelperTextActive]: isAnonymous,
          [styles.anonymousCheckboxLeft]: justify === 'left',
          [styles.anonymousCheckboxCenter]: justify === 'center',
          [styles.anonymousCheckboxRight]: justify === 'right',
        })}
      >
        Anonymous posts cannot be edited or deleted
      </div>
    </>
  );
};

export default AnonymousPostBlock;
